import { createReducer, on } from "@ngrx/store"
import { billActions } from "../bill.actions"

export interface PresignedUrlState {
    presignedUrl: string|null,
    status: 'pending'|'loading'|'loaded'|'error'
}

export const initialState: PresignedUrlState = {
    presignedUrl: null,
    status: 'pending'
}

export const presignedUrlReducer = createReducer(
    initialState,
    on(billActions.getPresignedUrl, (state) => ({
        ...state,
        presignedUrl: null,
        status: 'loading' as const
    })),
    on(billActions.getPresignedUrlSuccess, (state, {payload}) => ({
        ...state,
        presignedUrl: payload,
        status: 'loaded' as const
    })),
    on(billActions.getPresignedUrlFail, (state) => ({
        ...state,
        presignedUrl: null,
        status: 'error' as const
    }))
)